"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol id=icon-close viewbox="0 0 24 24"><path d="M23.205 1.79L21.415 0l-9.813 9.812L1.79 0 0 1.79l9.812 9.812L0 21.415l1.79 1.789 9.812-9.811 9.813 9.811 1.79-1.789-9.813-9.813z"></path></symbol>';
};